

















import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator'
import { IImageVariants } from '~/assets/interfaces/images'
import { IStyle } from '~/assets/interfaces/classes'

@Component
export default class ComponentImage extends Vue {
  @Prop({
    type: [Object, String, Array],
    default: () => {},
  })
  private image!: IImageVariants | string

  @Prop({ type: String, default: '' }) private alt!: string
  @Prop({ type: String, default: '' }) private title!: string
  @Prop({ type: Boolean, default: false }) private cover!: boolean
  @Prop({ type: Boolean, default: true }) private lazyload!: boolean
  @Prop({ type: String, default: 'low' }) private fetchpriority!: string
  @Prop({ type: Boolean, default: false }) private multiply!: boolean
  @Prop({ type: Boolean, default: false }) private absolute!: boolean
  @Prop({ type: [String, Number, Array], default: '' }) private aspectRatio!:
    | string
    | number
    | [number, number]
    | Array<number | string>

  private $style!: IStyle

  get computedClassImage() {
    return {
      [this.$style.image]: true,
      [this.$style.cover]: this.cover,
      [this.$style.multiply]: this.multiply,
    }
  }

  get computedStyleImageWrapper() {
    const aspectRatio = this.normalizeAspectRatio()
    return aspectRatio ? { aspectRatio } : {}
  }

  private get computedClassImageWrapper() {
    return {
      [this.$style.imageWrapper]: true,
      [this.$style.cover]: this.cover && !this.absolute,
      [this.$style.absolute]: this.absolute,
    }
  }

  private renderedImage = ''

  private imageRender(): string {
    if (typeof this.image === 'string') return this.image
    if (Array.isArray(this.image)) return this.image.join(', ')
    return Object.entries(this.image)
      .map(([key, val]) => `${val} ${key}`)
      .join(', ')
  }

  @Watch('image', { immediate: true })
  private onImageChange() {
    this.updateRenderedImages()
  }

  private updateRenderedImages() {
    this.renderedImage = this.imageRender()
  }

  private normalizeAspectRatio(): string | null {
    const ratio = this.aspectRatio

    if (Array.isArray(ratio)) {
      const [width, height] = ratio
      const w = Number(width)
      const h = Number(height)
      return w > 0 && h > 0 ? `${w} / ${h}` : null
    }

    if (typeof ratio === 'number') {
      return ratio > 0 ? String(ratio) : null
    }

    if (typeof ratio === 'string') {
      const cleaned = ratio.trim().replace(/,/g, ' / ').replace(/\s+/g, ' ')
      return cleaned ? cleaned : null
    }

    return null
  }
}
